import "./footer.css";


import ContactForm from "./contactForm";
import Info from "./info";

export default function Footer() {
 

  return (
    <div
    id="footer"
      className="d-flex justify-content-center align-items-center footer font-aeonik position-relative"
      style={{
        borderTop: "2px solid #ffffff6e",
        borderRadius: "20px",
        marginTop: '6em'
      }}
    >
      {/* <div className="last-updated">
        Last Updated: <em>3-21-2024</em>
      </div> */}
      <div
        className="row w-100 justify-content-center d-flex position-relative"
        style={{
          padding: "3em 0",
        }}
      >
        <Info />

        <ContactForm />
      </div>
    </div>
  );
}
